<template>
<div>
  <p v-if="role=='user'">Dashboard contents will appear here.</p>
    <div class="vx-row" v-if="role!='user'">

            <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/3 xl:w-1/3">
                <statistics-card-line
                  hideChart
                  class="mb-base"
                  icon="MailIcon"
                  icon-right
                  :statistic="total_counter.invited"
                  statisticTitle="Pending Invitations" />
            </div>

            <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/3 xl:w-1/3">
                <statistics-card-line
                  hideChart
                  class="mb-base"
                  icon="AlertOctagonIcon"
                  icon-right
                  :statistic="total_counter.pending"
                  statisticTitle="Pending Approvals"
                  color="danger" />
            </div>
      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/3 xl:w-1/3">
        <statistics-card-line
          hideChart
          class="mb-base"
          icon="UserCheckIcon"
          icon-right
          :statistic="total_counter.users"
          statisticTitle="Total Users"
          color="success" />
      </div>
      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/3 xl:w-1/3">
        <statistics-card-line
          hideChart
          class="mb-base"
          icon="UserIcon"
          icon-right
          :statistic="total_counter.managers"
          statisticTitle="Total Managers"
          color="danger" />
      </div>
            <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/3 xl:w-1/3">
                <statistics-card-line
                  hideChart
                  class="mb-base"
                  icon="SmileIcon"
                  icon-right
                  :statistic="total_counter.students"
                  statisticTitle="Total Students"
                  color="success" />
            </div>


              <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/3 xl:w-1/3">
                <statistics-card-line
                  hideChart
                  class="mb-base"
                  icon="NavigationIcon"
                  icon-right
                  :statistic="total_counter.locations"
                  statisticTitle="Total Locations"
                  color="primary" />
            </div>

        </div>
   <vs-row v-if="role!='user'">
<vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-w="4.8">
          <vx-card title="Support Tracker" style="height: 409px">

              <!-- CARD ACTION -->
        <template slot="actions">
          <vs-dropdown vs-trigger-click class="cursor-pointer" >
          <small class="flex cursor-pointer">
          <span v-html="ticket_graph_filter"></span>
          <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" class="ml-1" />
          </small>
        <vs-dropdown-menu class="w-32">
            <vs-dropdown-item @click="ticketReport()">Last 7 days</vs-dropdown-item>
            <vs-dropdown-item @click="getTicketGraph('LastMonth')">Last Month</vs-dropdown-item>

        </vs-dropdown-menu>
         </vs-dropdown>
        </template>

              <div slot="no-body" >
                  <div class="vx-row text-center">

                      <!-- Open Tickets Heading -->
                      <div class="vx-col w-full lg:w-1/5 md:w-full sm:w-1/5 flex flex-col justify-between mb-4 lg:order-first md:order-last sm:order-first order-last">
                          <div class="lg:ml-6 lg:mt-6 md:mt-0 md:ml-0 sm:ml-6 sm:mt-6">
                              <h1 class="font-bold text-5xl">{{ supportTracker.total }}</h1>
                              <small>Tickets</small>
                          </div>
                      </div>

                      <!-- Chart -->
                      <div class="vx-col w-full lg:w-4/5 md:w-full sm:w-4/5 justify-center mx-auto lg:mt-0 md:mt-6 sm:mt-0 mt-6">
                          <vue-apex-charts type="radialBar" height="340" :options="ticketchart" :series="supportTracker.percent" />
                      </div>
                  </div>

                  <!-- Support Tracker Meta Data -->
                  <div class="flex flex-row justify-between px-8 pb-4 mt-4">
                      <p class="text-center">
                        <span class="block">New Tickets</span>
                        <span class="text-2xl font-semibold">{{supportTracker.new}}</span>
                      </p>
                      <p class="text-center">
                        <span class="block">Open Tickets</span>
                        <span class="text-2xl font-semibold">{{ supportTracker.opened }}</span>
                      </p>
                      <p class="text-center">
                        <span class="block">Resolved</span>
                        <span class="text-2xl font-semibold">{{ supportTracker.waiting }}</span>
                      </p>
                  </div>
              </div>
          </vx-card>
</vs-col>
 <vs-col  vs-type="flex" vs-justify="center" vs-align="center" vs-w="7" class="ml-4" >
      <vx-card  style="height: 409px">
        <span >
          <h5>Upcoming Birthday(s)</h5>
        <!-- <img  src="@/assets/images/pages/birthday.svg" class="responsive w-10 h-10"> -->
            </span>        <!-- FRIENDS LIST -->
         <div v-if="StudentBirthday.length > 0">
           <vs-row>
  <vs-col v-for="(student, index) in StudentBirthday" :key="index" vs-type="flex" vs-justify="left" vs-align="center" vs-w="6" >
    <vs-row>
      <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-w="8" >

        <div class="friend-suggesions-list mt-5 flex">
          <div v-if="student.image" class="mr-3"><vs-avatar class="m-0" :src="img_cdn+student.image"  size="35px" /></div>
          <div v-else class="mr-3"><vs-avatar class="m-0" :src="student.image"  size="35px" /></div>
          <div class="leading-tight">
            <p class="font-medium">{{ student.fname }} {{ student.lname }}</p>
            <span class="text-xs">{{ student.dob | formatDate  }} - {{student.age}}</span>

          </div>
        </div>
      </vs-col>
      <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-w="4">
        <ul  class="flex"  style="margin-top: 0px;line-height:1;display:inline-display">
          <li class="flex">
            <img  src="@/assets/images/pages/birthday.svg" class="responsive w-5 h-5"> <small class="text-xs mt-2 ml-1">{{student.day}}</small>
          </li>
          <!-- <li>
            <small class="text-xs">{{student.age}}</small>
          </li> -->
        </ul>
      </vs-col>
    </vs-row>
  </vs-col>
</vs-row>

                    </div>
                <p v-else class="mt-5">No Upcoming Birthdays</p>
                    <!-- <template slot="footer">
                    <vs-button icon-pack="feather" icon="icon-plus" class="w-full">Load More</vs-button>
                    </template> -->
                </vx-card>
 </vs-col >
 </vs-row>
 <br>
  <vs-row v-if="role!='user'">
  <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-w="4.8">
     <vx-card title="Who Logged In Most">
    <vue-apex-charts type="bar" :height="25 * fullname.length + 45"  :options="Fullname" :series="todayLogin"></vue-apex-charts>
  </vx-card>
  </vs-col>
  <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-w="0.2">

  </vs-col>
   <vs-col   vs-type="flex" vs-justify="center" vs-align="center" vs-w="7">
      <vx-card title="Last Week Logins">
        <vue-apex-charts type="area" height="170" :options="weeklyData.chartOptions" :series="Series"></vue-apex-charts>
      </vx-card>
  </vs-col>
</vs-row>
 <br>
  <vs-row v-if="role!='user'">
  <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-w="4.8">
     <vx-card title="Who Watched Most">
   <vue-apex-charts type="bar" :height=" 25 * userNames.length+45 " :options="getUsersName" :series="getwatchTime"></vue-apex-charts>  </vx-card>
  </vs-col>
  <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-w="0.2">

  </vs-col>
   <vs-col   vs-type="flex" vs-justify="center" vs-align="center" vs-w="7">
      <vx-card title="Last Week Watch Time">
        <vue-apex-charts type="area" height="170" :options="weeklyWatchTimeData.chartOptions" :series="weeklyWatchTimeData.series"></vue-apex-charts>
      </vx-card>
  </vs-col>
</vs-row>

  <!-- <div class="vx-row mt-5">
       <div class="vx-col w-full lg:w-1/3 mb-base">
                <vx-card title="Cameras">

                    <div slot="no-body">
                        <vue-apex-charts type="pie" height="334" class="my-12" :options="cameraChart" :series="cameraSeries" />

                        <ul class="mb-1">
                            <li v-for="customerData in cameraStudent" :key="customerData.customerType" class="flex justify-between py-3 px-6 border d-theme-border-grey-light border-solid border-r-0 border-l-0 border-b-0">
                                <span class="flex items-center">
                                    <span class="inline-block h-3 w-3 rounded-full mr-2" :class="`bg-${customerData.color}`"></span>
                                    <span class="font-semibold">{{ customerData.customerType }}</span>
                                </span>
                                <span>{{ customerData.counts }}</span>
                            </li>
                        </ul>
                    </div>

                </vx-card>
            </div>
</div> -->
</div>
</template>
<script>
import VueApexCharts from 'vue-apexcharts'
import {GET_LOGIN_DATE_REPORT, GET_LOGIN_REPORT, GET_LOGIN_WEEK_REPORT,GET_REPORT_CAMERAS_LIST,WATCH_TIME_MONTHLY_REPORT,
WATCH_TIME_REPORT,WATCH_TIME_REPORT_BY_CAMERA,WATCH_TIME_REPORT_BY_DATE
,GET_UPCOMING_BIRTHDAY,
ALL_TICKET_CHART,
FILTER_TICKET_CHART,
TOTAL_COUNTER,
CAMERA_CHART
 } from '@/graphql'
import {colors} from '../../themeConfig'
import moment from 'moment'
import StatisticsCardLine from '@/components/statistics-cards/StatisticsCardLine.vue'
export default {
  components: {
  VueApexCharts,
  StatisticsCardLine,
  },
   data () {
    return {
      DataNotFound: false,
      ticket_graph_filter:'Last 7 days',
      fullname: [],
      todayLogin: [],
      WeekDates: [],
      WeekLoginCount: [],
      options: ['one', 'two', 'three'],
      userNames: [],
      userWatchTime: [],
      DaysData: [],
      WatchTimeData: [],
      CamerasList: [],
      StudentBirthday:[],
      CameraId: 'All',
      role:'',
      img_cdn: '',
      ticketchart:{
         "plotOptions": { "radialBar": { "size": 158, "offsetY": -30, "startAngle": -150, "endAngle": 150, "hollow": { "size": "65%" }, "track": { "background": "rgba(0,0,0,0)", "strokeWidth": "100%" }, "dataLabels": { "value": { "offsetY": 30, "color": "#99a2ac", "fontSize": "2rem" } } } }, "colors": [ "#EA5455" ], "fill": { "type": "gradient", "gradient": { "shade": "dark", "type": "horizontal", "shadeIntensity": 0.5, "gradientToColors": [ "#7367F0" ], "inverseColors": true, "opacityFrom": 1, "opacityTo": 1, "stops": [ 0, 100 ] } }, "stroke": { "dashArray": 8 }, "chart": { "sparkline": {} }, "labels": [ "Completed Tickets" ]
      },
      cameraStudent:[ { "customerType": "Cam3", "counts": 890, "color": "primary" }, { "customerType": "Cam1", "counts": 258, "color": "warning" }, { "customerType": "Cam2 ", "counts": 149, "color": "danger" } ],
       supportTracker: {},
         total_counter:'',
         Camera_Name:[],
         Camera_Color:[],
         Camera_Count:[],
    }
  },
   filters: {
  formatDate: function (value) {
    if (value) {
    return moment(String(value)).format('MM/DD/YYYY')
  }
  }
   },
  computed: {
    // cameraChart(){
    // return { "labels": this.CameraName, "dataLabels": { "enabled": false }, "legend": { "show": false }, "chart": { "type": "pie", "offsetY": 0, "dropShadow": { "enabled": false, "blur": 5, "left": 1, "top": 1, "opacity": 0.2 }, "toolbar": { "show": false } }, "stroke": { "width": 5 }, "colors": this.CameraColor, "fill": { "type": "gradient", "gradient": { "gradientToColors": [ "#9c8cfc", "#FFC085", "#f29292" ] } } }
    // },
    // cameraSeries() {
    //    return this.Camera_Count
    //   },

    Series() {
      return [{
        name: ' Logins# ',
        data: this.WeekLoginCount
      },
      ]
    },
    weeklyData() {
      return {
        colors: [colors.primary],
        series: [{
          name: 'Logins# ',
          data: this.WeekLoginCount
        },
        ],
        chartOptions: {
          dataLabels: {
            enabled: false
          },
          chart: {
            sparkline: {
              enabled: true
            },
          },
          stroke: {
            curve: 'smooth',
            colors: colors.primary,
          },
          fill: {
            type: 'solid',
            colors: colors.primary,
            opacity: [1],
          },
          tooltip: {
            enabled: true,
            y: {
              formatter: function (value) {
                return value
              }
            },
          },
          xaxis: {

            categories: this.WeekDates
          },
          yaxis: {
            labels: {
              show: false,
            }
          },
        }
      }

    },
    Fullname() {
      return {
        colors: colors.primary,
        plotOptions: {
          bar: {
            horizontal: true,
          }
        },
           chart: {
            toolbar: {
              show: false
            },
          },
        tooltip: {
         enabled: true,
         y: {
         formatter: function(value) {
         return value
         }
         },
      },
          dataLabels: {
            enabled: false,
          },
          xaxis: {
          categories: this.fullname,
          labels: {
          show: false,
          }
          },
      }
    },
    charthight(){
        return 50*this.fullname.length
    },
    getUsersName() {
      return {
        colors: colors.primary,
        plotOptions: {
          bar: {
            horizontal: true,
          }
        },
        chart: {
          toolbar: {
            show: false
          },
        },
        tooltip: {
          enabled: true,
          y: {
            formatter: function (value) {
              return value + ' Minutes'
            }
          },
        },
        dataLabels: {
          enabled: false
        },
        xaxis: {
          categories: this.userNames,
          labels: {
            show: false,
          }
        }
      }
    },
    getwatchTime() {
      return [{name: 'Watch Time', data: this.userWatchTime}]
    },
    weeklyWatchTimeData() {
      return {
        colors: [colors.primary],
        series: [{
          name: 'Watch Time ',
          data: this.WatchTimeData
        }
        ],
        chartOptions: {
          dataLabels: {
             enabled: false
           },
           chart: {
             sparkline: {
               enabled: true
             },
           },
          stroke: {
            curve: 'smooth',
            colors: colors.primary,
          },
          fill: {
            type: 'solid',
            colors: colors.primary,
            opacity: [1],
          },
          tooltip: {
            enabled: true,
            y: {
              formatter: function (value) {
                return value + ' Minutes'
              }
            },
          },
          xaxis: {

            categories: this.DaysData,
          },
          yaxis: {
            labels: {
              show: false,
            }
          },
        }
      }

    },
    CameraName(){
      return  this.Camera_Name
    },
    CameraColor(){
      return  this.Camera_Color
    },
    CameraCount(){
      return  this.Camera_Count
    }

  },
   methods: {

    GetReport(date){
      this.$apollo
       .mutate({
          mutation: GET_LOGIN_REPORT,
           variables: {
            date: date,
          }
        }).then(response => {
          var todaylogin=[];
          var todayloginName=[];
         if(response) {
           if (response.data.getLoginReport.user == '') {
             todaylogin.push(0)
             todayloginName.push("Data Not Found")
             this.todayLogin = [{name: 'Logins# ', data:todaylogin}]
             this.fullname = todayloginName
           } else {

             let limit = response.data.getLoginReport.user.length < 4? response.data.getLoginReport.user.length : 4;

             for (let i = 0; i < limit; i++) {
               todaylogin.push(response.data.getLoginReport.user[i].login_counter)
               todayloginName.push(response.data.getLoginReport.user[i].users.fname + ' ' + response.data.getLoginReport.user[i].users.lname)
             }
             this.todayLogin = [{name: 'Logins# ', data:todaylogin}]
             this.fullname = todayloginName
           }

         }
        })
        .catch(error => {
        });
  },
  getFilterReport(){
    this.$apollo
       .mutate({
          mutation: GET_LOGIN_DATE_REPORT,
           variables: {
            fromDate: this.fromDate,
            toDate: this.toDate
          }
        }).then(response => {
          var todaylogin=[];
          var todayloginName=[];
         if(response) {
           if (response.data.getLoginDateReport.user == '') {
             todaylogin.push(0)
             todayloginName.push("Data Not Found")
             this.todayLogin = [{name: 'Logins#', data: todaylogin}]
             this.fullname = todayloginName
           } else {

              let limit = response.data.getLoginDateReport.user.length < 4? response.data.getLoginDateReport.user.length : 4;

              //  for (let i = 0; i < response.data.getLoginDateReport.user.length; i++) {

              for (let i = 0; i < limit; i++) {
               todaylogin.push(response.data.getLoginDateReport.user[i].login_counter)
               todayloginName.push(response.data.getLoginDateReport.user[i].users.fname + ' ' + response.data.getLoginDateReport.user[i].users.lname)
             }

             this.todayLogin = [{name: 'Logins#', data: todaylogin}]
             this.fullname = todayloginName
           }
         }
        })
        .catch(error => {
        });

  },
  GetWeekReport(date){
    this.$apollo
       .mutate({
          mutation: GET_LOGIN_WEEK_REPORT,
           variables: {
            date: date,
          }
        }).then(response => {

      this.WeekDates = response.data.getLoginWeekReport.data.lables
      this.WeekLoginCount = response.data.getLoginWeekReport.data.values

    }).catch(error => {
        });
  },
   watchTimeMonthlyReport() {
      this.$apollo
        .query({
          query: WATCH_TIME_MONTHLY_REPORT,
        }).then(response => {
        var totalTimeData = [];
        var usersData = [];
        if (response) {

          if (response.data.watchTimeMonthlyReport.data.length == 0) {

            totalTimeData.push(0)
            usersData.push("Data Not Found")

            this.userWatchTime = totalTimeData
            this.userNames = usersData

          } else {
            // for (let i = 0; i < response.data.watchTimeMonthlyReport.data.length; i++) {
              let limit = response.data.watchTimeMonthlyReport.data.length < 4? response.data.watchTimeMonthlyReport.data.length : 4;

              for (let i = 0; i < limit; i++) {
              totalTimeData.push(response.data.watchTimeMonthlyReport.data[i].minutes)
              usersData.push(response.data.watchTimeMonthlyReport.data[i].user.fname + ' ' + response.data.watchTimeMonthlyReport.data[i].user.lname)
            }

            this.userWatchTime = totalTimeData
            this.userNames = usersData
            this.getCamerasList();
          }

        }

      })
        .catch(error => {
        });
    },
    getWatchTimeReportByDate() {
      this.$apollo
        .query({
          query: WATCH_TIME_REPORT_BY_DATE,
          variables: {
            fromDate: this.fromDate,
            toDate: this.toDate
          }
        }).then(response => {
        if (response) {
          var totalTimeData = [];
          var usersData = [];

          if (response.data.watchTimeReportByDate.data.length == 0) {
            totalTimeData.push(0)
            usersData.push("Data Not Found")
            this.userWatchTime = totalTimeData
            this.userNames = usersData
          } else {
            for (let i = 0; i < response.data.watchTimeReportByDate.data.length; i++) {
              totalTimeData.push(response.data.watchTimeReportByDate.data[i].minutes)
              usersData.push(response.data.watchTimeReportByDate.data[i].user.fname + ' ' + response.data.watchTimeReportByDate.data[i].user.lname)

            }
          }
          this.userWatchTime = totalTimeData
          this.userNames = usersData

        }
      })
        .catch(error => {
        });

    },
    SearchByCamera() {
//refresh the selected dates again after submit data
      this.toDate = this.toDate
      this.fromDate = this.fromDate

      this.$apollo
        .query({
          query: WATCH_TIME_REPORT_BY_CAMERA,
          variables: {
            fromDate: this.fromDate,
            toDate: this.toDate,
            camera_id: this.CameraId.id,
          }
        }).then(response => {
        if (response) {
          var totalTimeData = [];
          var usersData = [];

          if (response.data.watchTimeReportByCamera.data.length == 0) {
            totalTimeData.push(0)
            usersData.push("Data Not Found")
            this.userWatchTime = totalTimeData
            this.userNames = usersData
          } else {
            for (let i = 0; i < response.data.watchTimeReportByCamera.data.length; i++) {
              totalTimeData.push(response.data.watchTimeReportByCamera.data[i].minutes)
              usersData.push(response.data.watchTimeReportByCamera.data[i].user.fname + ' ' + response.data.watchTimeReportByCamera.data[i].user.lname)

            }
          }
          this.userWatchTime = totalTimeData
          this.userNames = usersData

        }
      })
        .catch(error => {
        });

    },
    watchTimeWeeklyReport() {
      var today = new Date().toISOString().slice(0, 10)
      this.$apollo
        .mutate({
          mutation: WATCH_TIME_REPORT,
          variables: {
            date: today,
          }
        }).then(response => {
        this.DaysData = response.data.watchTimeWeeklyReport.data.lables
        this.WatchTimeData = response.data.watchTimeWeeklyReport.data.values

      }).catch(error => {
      });
    },
    getCamerasList() {
      this.$apollo
        .query({
          query: GET_REPORT_CAMERAS_LIST,
        })
        .then(response => {
          this.CamerasList = response.data.cameras
        })
    },
  getBirthday(){
       this.$apollo
        .query({
          query: GET_UPCOMING_BIRTHDAY,
        })
        .then(response => {
          this.StudentBirthday = response.data.studentsBirthday
        })
  },
  getTicketGraph(filter){
    this.ticket_graph_filter='Last Mounth'
    this.$apollo
        .mutate({
          mutation: FILTER_TICKET_CHART,
          variables: {
            filter: filter,
          }
        }).then(response => {
          this.supportTracker=response.data.FilterTicketChart

      }).catch(error => {
      });
  },
  ticketReport(){
    this.ticket_graph_filter='Last 7 days'
      this.$apollo
        .query({
          query: ALL_TICKET_CHART,
        })
        .then(response => {
          this.supportTracker=response.data.TicketChart
        })
  },
  totalCounter(){
    this.$apollo
        .query({
          query: TOTAL_COUNTER,
        })
        .then(response => {
          this.total_counter=response.data.TotalCounter
        })
  },
  //  CameraReport(){
  //     this.$apollo
  //       .query({
  //         query: CAMERA_CHART,
  //       })
  //       .then(response => {
  //         this.Camera_Name=response.data.CameraChart.name
  //         this.Camera_Color=response.data.CameraChart.color
  //         this.Camera_Count=response.data.CameraChart.count
  //       })

  // }
  },
  created () {
    this.totalCounter();
    this.ticketReport();
    this.getBirthday();
     this.img_cdn=process.env.VUE_APP_IMAGES_CDN_LINK
    const userRoles = JSON.parse(localStorage.getItem('user-roles'))
    this.role=userRoles[0]['name']
    if(this.role!='user'){
    this.watchTimeMonthlyReport();
    this.watchTimeWeeklyReport();
    var today = new Date()
    var setcurrentDayDate =today.toISOString();
    var setLastMonthDate =today.setDate(today.getDate() - 30);
    var lastMonthDate = new Date(setLastMonthDate).toISOString();
    this.toDate = setcurrentDayDate;
    this.fromDate = lastMonthDate
    this.GetReport(today);
    this.GetWeekReport(today);

    // this.CameraReport();
     }
  },
}
</script>
